import { Header } from 'components/Layout/Header';
import { usePageCarto } from 'hooks/usePageCarto';
import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCanEdit } from 'hooks/useCanEdit';
import { PageCartoChartPanel } from '../Editor/PageCartoChartPanel/PageCartoChartPanel';
import { PageCartoMap } from '../Editor/PageCartoMap';

export const PageCartoView: FC = () => {
  const { data } = usePageCarto();
  const navigate = useNavigate();
  const canEdit = useCanEdit();

  useEffect(() => {
    const container = document.querySelector(
      '#pagecarto-content-container'
    ) as Element | null;
    if (!container) {
      return;
    }

    const handleLinkClick = (event: Event) => {
      const anchor = (event.target as HTMLElement).closest('a');
      if (
        anchor &&
        anchor.tagName === 'A' &&
        anchor.getAttribute('href')?.startsWith('/')
      ) {
        event.preventDefault();
        const newPath = anchor.getAttribute('href') as string;
        navigate(newPath);
      }
    };

    container.addEventListener('click', handleLinkClick);
    return () => {
      container.removeEventListener('click', handleLinkClick);
    };
  }, [data, navigate]);

  return (
    <div className="h-full">
      <Header>{data?.data.name}</Header>
      <div className="relative w-[50%] float-right ml-5 z-[999] overflow-hidden">
        <PageCartoMap canEdit={canEdit} />
        <div className="w-[50%] absolute z-50 bottom-0 right-0 opacity-90">
          <PageCartoChartPanel readOnly={true} />
        </div>
      </div>
      <div
        id="pagecarto-content-container"
        className="border-1 border-blue-600 overflow-y-auto inline"
        dangerouslySetInnerHTML={{ __html: data?.data.html || '' }}
      ></div>

      <div style={{ clear: 'both' }}></div>
      <div className="col-span-6 row-span-2 p-4 relative"></div>
      <div className="col-span-6 row-span-1 my-1"></div>
    </div>
  );
};
